import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class IonModalService {
    private breakpointsSubject = new BehaviorSubject<number[]>([]);
    breakpoints$ = this.breakpointsSubject;

    private scrollToTopSubject = new Subject();
    scrollToTop$ = this.scrollToTopSubject.asObservable();

    setBreakpoints(breakpoints: number[]): void {
        this.breakpointsSubject.next(breakpoints);
    }
    getBreakpoints(): number[] {
        return this.breakpointsSubject.value;
    }
    setCurrentBreakpoint(breakpoint: number): void {
        this.breakpointsSubject.next([breakpoint, ...this.breakpointsSubject.value.slice(1)]);
    }
    scrollToTopTrigger(): void {
        this.scrollToTopSubject.next();
    }
}
